import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../../../layoutcontainers/DashboardLayout'
import MaterialBox from '../../../../components/MaterialBox'
import MaterialTypography from '../../../../components/MaterialTypography'
import { Grid, Stack, Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import MaterialSelect from '../../../../components/MaterialSelect'
import MaterialDatePicker from '../../../../components/MaterialDatePicker'
import CollapsibleTable from '../../../../components/CollapsibleTable'
import MaterialButton from '../../../../components/MaterialButton'
import axios from 'axios'
import TaskCreationForm from '../../../taskCreation/taskCreationForm/index.jsx'
import { BASE_URL, fetchData, postData } from '../../../Utils/Baseurl'
import { useSnackbar } from '../../../../components/SnackbarProvider';
import { useLoading } from '../../../../context/loadingcontext';
import { useLocation } from 'react-router-dom';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import ApprovalTimeline from '../ApprovalTimeline';

const TaskCreationList = () => {
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();
  const location = useLocation();
  const { project_id } = location.state || {};

  const [filters, setFilters] = useState({
    milestone: null,
    employee: null,
    startDate: '',
    endDate: '',
    date: '',
    status: null,
    search: ''
  });

  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [milestones, setMilestone] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [baseline, setBaseline] = useState(null);
  const [taskCountStatus, setTaskCountStatus] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [approvalHistoryData, setApprovalHistoryData] = useState([]);
  const [dialogTaskList, setDialogTaskList] = useState([]);
  const [permission, setPermission] = useState(null);
  const [isFreezeEnabled, setIsFreezeEnabled] = useState(false);

  const [rejectComment, setRejectComment] = useState('');

  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);

  console.log(isFreezeEnabled, 'isFreezeEnabled')



  const handleOpen = () => {
    setOpen(true);
    fetchApprovalHistory();
  };

  const handleClose = () => setOpen(false);

  const fetchApprovalHistory = async () => {
    try {
      const response = await fetchData(`api/approve_history/?project_id=${project_id}`)
      const data = response?.data;
      if (data) {
        setApprovalHistoryData(data);
      } else {
        setApprovalHistoryData([]);
      }
    } catch (error) {
      console.error("Error fetching approval history:", error);
      showSnackbar("Failed to fetch approval history", "error");
    }
  };

  useEffect(() => {
    if (project_id) {
      fetchTaskList();
    }
  }, [project_id, filters, currentPage, pageSize, sortConfig]);

  useEffect(() => {
    if (project_id) {
      fetchMilestones();
      fetchEmployees();
      fetchPermissions();
    }
  }, [project_id]);

  const fetchTaskList = async () => {
    try {
      const params = {
        project_id: project_id,
        milestone_id: filters.milestone?.value,
        assignee_id: filters.employee?.value,
        start_date: filters.startDate,
        end_date: filters.endDate,
        actual_date: filters.date,
        status: filters.status?.value,
        page: currentPage,
        page_size: pageSize,
        search: filters.search,
        ordering: sortConfig.key ? (sortConfig.direction === 'asc' ? sortConfig.key : `-${sortConfig.key}`) : undefined
      };
      setCirleLoading(true);
      const user = JSON.parse(sessionStorage.getItem("currentUser"));
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}api/gettask/${user}/`, {
        params: params,
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      const results = response.data?.results || response.data?.data || [];
      setTaskList(results);

      if (response.data?.count !== undefined) {
        setTotalCount(response.data.count);
      } else {
        setTotalCount(results.length);
      }

      setIsFreezeEnabled(response.data?.freeze_status);
      setBaseline(response.data?.baseline_name);
      setTaskCountStatus(response.data?.task_details);

    } catch (error) {
      console.error("Error fetching task list:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const fetchMilestones = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}api/get_projectmilestone/`, {
        params: { project_id: project_id },
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      const milestoneOptions = response.data?.data?.map(item => ({
        value: item.id,
        label: item.milestone_name
      })) || [];
      setMilestone(milestoneOptions);

    } catch (error) {
      console.error("Error fetching milestones:", error);
    }
  };

  const fetchEmployees = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.get(`${BASE_URL}api/project_employees/`, {
        params: { project_id: project_id },
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      const employeeOptions = response.data?.data?.map(item => ({
        value: item.id,
        label: item.employee_name
      })) || [];
      setEmployees(employeeOptions);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchPermissions = async () => {
    try {
      const user_id = parseInt(sessionStorage.getItem("currentUser"));
      const payload = {
        project_id: project_id,
        user_id: user_id
      }
      const response = await postData(`api/check_approval/`, payload)
      setPermission(response);
    } catch (error) {
      console.error(error);
    }
  }

  // const handleOpenUploadDialog = () => {
  //   setOpenUploadDialog(true);
  // };

  const handleCloseUploadDialog = () => {
    setOpenUploadDialog(false);
  };

  const handleFileUpload = (event) => {
    setSelectedDocument(event.target.files[0]);
  };

  const handleOpenDialog = () => {
    setSelectedTask(null);
    setDialogOpen(true);
    fetchDialogTaskList();
  }

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedTask(null);
  }

  const handleRejectDialogOpen = () => {
    setRejectDialogOpen(true);
  }

  const handleRejectDialogClose = () => {
    setRejectDialogOpen(false);
  }

  const fetchDialogTaskList = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("currentUser"));
      const token = sessionStorage.getItem("token");
      const params = {
        project_id: project_id,
        page: 1,
        page_size: 100,
      };
      setCirleLoading(true);
      const response = await axios.get(`${BASE_URL}api/gettask/${user}/`, {
        params: params,
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });
      const results = response.data?.results || response.data?.data || [];
      setDialogTaskList(results);
    } catch (error) {
      console.error("Error fetching dialog task list:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleSubmitDocument = async () => {
    if (!selectedDocument) {
      showSnackbar("Please select a document", "error");
      return;
    }

    try {
      setCirleLoading(true);
      const token = sessionStorage.getItem("token");
      const user = JSON.parse(sessionStorage.getItem("currentUser"));
      const formData = new FormData();
      formData.append("project", project_id);
      formData.append("document", selectedDocument);
      formData.append("upload_by", user);
      formData.append("document_name", 'Impact Analysis Doc');

      const response = await axios.post(`${BASE_URL}api/documents/`, formData, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });

      if (response.data?.status || response.status === 201 || response.status === 200) {
        showSnackbar(response.data?.message || "Document uploaded successfully", "success");
        setOpenUploadDialog(false);
        setSelectedDocument(null);
      } else {
        showSnackbar(response.data?.message || "Failed to upload document", "error");
      }
    } catch (error) {
      console.error("Error uploading document:", error);
      showSnackbar(error?.response?.data?.message || error?.message || "An error occurred", "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const columns = [
    { key: 'task_code', header: 'Task ID', showDisplay: true },
    { key: 'milestone_name', header: 'Milestone', showDisplay: true },
    { key: 'module_name', header: 'Module', showDisplay: true },
    { key: 'task_title', header: 'Task', showDisplay: true },
    { key: 'start_date', header: 'Date', showDisplay: true },
    { key: 'assignee_name', header: 'Employee', showDisplay: true },
    { key: 'assigned_hours', header: 'Assigned Hours', showDisplay: true },
    { key: 'status', header: 'Status', showDisplay: true }
  ];

  const handleFilterChange = (name, value) => {
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
    setCurrentPage(1);
  };

  const handleStartDateChange = (data) => {
    if (!data || !data[0]) return;
    const date = new Date(data[0]);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    handleFilterChange('startDate', formattedDate);
  };

  const handleEndDateChange = (data) => {
    if (!data || !data[0]) return;
    const date = new Date(data[0]);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    handleFilterChange('endDate', formattedDate);
  };

  const handleDateChange = (data) => {
    if (!data || !data[0]) return;
    const date = new Date(data[0]);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    handleFilterChange('date', formattedDate);
  };

  const handleEdit = (row) => {
    setSelectedTask(row);
    setDialogOpen(true);
    fetchDialogTaskList();
  };

  const handleDelete = (row) => {
    console.log('Delete row:', row);
  };

  // const handleNavigateTaskAdd = () => {
  //   navigate('/task-creation/task-list/add-task-creation', { state: { project_id: project_id } })
  // }


  const handleBaseline = async () => {
    try {
      setCirleLoading(true);
      const token = sessionStorage.getItem("token");
      const user = sessionStorage.getItem("currentUser")

      const response = await axios.post(`${BASE_URL}api/taskfreeze/`, {
        project_id: project_id,
        user_id: user,
        approved: true
      }, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.data?.status || response.status === 200) {
        showSnackbar(response.data?.message || 'Baseline created successfully', 'success');
        fetchTaskList();
      } else {
        showSnackbar(response.data?.message || 'Failed to create baseline', 'error');
      }
    } catch (error) {
      console.error('Error creating baseline:', error);
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while creating baseline';
      showSnackbar(errorMessage, 'error');
    } finally {
      setCirleLoading(false);
    }
  }

  const handleRejectBaseline = async () => {
    
    try {
      setCirleLoading(true);
      const token = sessionStorage.getItem("token");
      const user = parseInt(sessionStorage.getItem("currentUser"))

      const response = await axios.post(`${BASE_URL}api/taskfreeze/`, {
        project_id: project_id,
        user_id: user,
        comment: rejectComment,
        approved: false
      }, {
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (response.data?.status || response.status === 200) {
        showSnackbar(response.data?.message || 'Baseline rejected successfully', 'success');
        fetchTaskList();
      } else {
        showSnackbar(response.data?.message || 'Failed to reject baseline', 'error');
      }
    } catch (error) {
      console.error('Error rejecting baseline:', error);
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred while rejecting baseline';
      showSnackbar(errorMessage, 'error');
    } finally {
      setCirleLoading(false);
    }
  }

  const handleClearFilter = () => {
    setFilters({
      milestone: null,
      employee: null,
      startDate: '',
      endDate: '',
      date: '',
      status: null,
      search: ''
    });
  }

  const renderCellWithTooltip = (value, maxLength = 15) => {
    if (!value) return "-";

    const isTruncated = value.length > maxLength;
    const displayText = isTruncated
      ? value.substring(0, maxLength) + "..."
      : value;

    return (
      <span
        title={isTruncated ? value : ""}
        style={{
          display: "inline-block",
          maxWidth: "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          verticalAlign: "middle",
          cursor: isTruncated ? "pointer" : "default",
        }}
      >
        {displayText}
      </span>
    );
  };


  return (
    <DashboardLayout>
      <MaterialBox sx={{ padding: 1 }}>
        <Stack direction='row' alignItems='center' justifyContent='space-between' spacing={1}>
          <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 3 }}>
            <MaterialTypography variant='h5' color='dark' fontWeight='bold'>
              Task List
            </MaterialTypography>
            <MaterialTypography variant='caption' color='textSecondary'>
              View all task. You can also add the task here.
            </MaterialTypography>
          </MaterialBox>
          <MaterialBox sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <MaterialButton variant='outlined' color='dark' size='small' onClick={handleOpen}>
              History
            </MaterialButton>
            <MaterialButton variant='contained' color='dark' size='small' onClick={handleRejectDialogOpen}>
              Reject
            </MaterialButton>
            {permission?.allowed && !isFreezeEnabled && (
              <>
                <MaterialButton variant='contained' color='dark' size='small' onClick={handleBaseline}>
                  {baseline === -1 ? 'Baseline' : 'Request Rebaseline'}
                </MaterialButton>
                <MaterialButton variant='contained' color='dark' size='small' onClick={handleOpenDialog}>
                  {baseline === -1 ? 'Add Task' : 'Request to Add Task'}
                </MaterialButton>
              </>
            )}
            {/* {role === 'Project Manager' && projectManagerFreeze && !techLeadFreeze && (
              <>
                {baseline >= 0 && (
                  <IconButton color="dark" onClick={() => setOpenUploadDialog(true)} sx={{ mr: 1 }}>
                    <CloudUploadIcon />
                  </IconButton>
                )}
                <MaterialButton variant='contained' color='dark' size='small' onClick={handleBaseline}>
                  {baseline === -1 ? 'Baseline' : 'Approve Rebaseline'}
                </MaterialButton>
                <MaterialButton variant='contained' color='dark' size='small' onClick={handleRequestToAddTask}>
                  {baseline === -1 ? 'Add Task' : 'Request to Add Task'}
                </MaterialButton>
              </>
            )} */}
            {/* {role === 'Project Manager' && (
              <MaterialButton variant='contained' color='dark' size='small' onClick={handleOpenDialog}>
                {baseline === -1 ? 'Add Task' : 'Request to Add Task'}
              </MaterialButton>
            )} */}
            {/* {role === 'CTO' && ctoFreeze && !techLeadFreeze && (
              <>
                <MaterialButton variant='contained' color='dark' size='small' onClick={handleBaseline}>
                  {baseline === -1 ? 'Baseline' : 'Approve Rebaseline'}
                </MaterialButton>
              </>
            )} */}
          </MaterialBox>
        </Stack>

        <Grid container spacing={2} sx={{ mb: 2, mt: 1 }}>
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Milestone
              </MaterialTypography>
              <MaterialSelect
                size='small'
                name="milestone"
                placeholder="Select Milestone"
                value={filters.milestone}
                onChange={(selectedOption) => handleFilterChange('milestone', selectedOption)}
                options={milestones}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Employee
              </MaterialTypography>
              <MaterialSelect
                size='small'
                name="employee"
                placeholder="Select Employee"
                value={filters.employee}
                onChange={(selectedOption) => handleFilterChange('employee', selectedOption)}
                options={employees}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Start Date
              </MaterialTypography>
              <MaterialDatePicker
                name="startDate"
                type="date"
                value={filters.startDate}
                onChange={handleStartDateChange}
                input={{ size: 'small' }}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                End Date
              </MaterialTypography>
              <MaterialDatePicker
                name="endDate"
                type="date"
                value={filters.endDate}
                onChange={handleEndDateChange}
                input={{ size: 'small' }}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Date
              </MaterialTypography>
              <MaterialDatePicker
                name="date"
                type="date"
                value={filters.date}
                onChange={handleDateChange}
                input={{ size: 'small' }}
              />
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Stack spacing={1}>
              <MaterialTypography variant='caption' color='text' fontWeight='medium'>
                Status
              </MaterialTypography>
              <MaterialBox>
                <MaterialSelect
                  size='small'
                  name="status"
                  placeholder="Select Status"
                  value={filters.status}
                  onChange={(selectedOption) => handleFilterChange('status', selectedOption)}
                  options={[
                    { value: '0', label: 'Not Started' },
                    { value: '1', label: 'In Progress' },
                    { value: '3', label: 'On Hold' },
                    { value: '2', label: 'Completed' },
                    { value: '4', label: 'Aborted' }
                  ]}
                />
                <IconButton
                  onClick={handleClearFilter}
                  sx={{
                    backgroundColor: '#fff1f2',
                    '&:hover': { backgroundColor: '#ffe4e6' },
                    p: 0.8
                  }}
                >
                  <FilterAltOffIcon sx={{ color: "#F63049", fontSize: '1.2rem' }} />
                </IconButton>
              </MaterialBox>
            </Stack>
          </Grid>
        </Grid>

        {taskCountStatus && (
          <MaterialBox sx={{ mb: 3, mt: 3 }}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e3f2fd',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Total Assigned
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="primary" fontWeight="bold">
                    {taskCountStatus.total_assigned_hours || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e8f5e9',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Total Actual
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="success" fontWeight="bold">
                    {taskCountStatus.total_actual_hours || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#f3e5f5',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Total Tasks
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="dark" fontWeight="bold">
                    {taskCountStatus.total_tasks || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e8f5e9',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Completed
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="success" fontWeight="bold">
                    {taskCountStatus.completed_tasks || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#e1f5fe',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    In Progress
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="info" fontWeight="bold">
                    {taskCountStatus.inprogress || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#fff3e0',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    On Hold
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="warning" fontWeight="bold">
                    {taskCountStatus.onhold || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#ffebee',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Aborted
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="error" fontWeight="bold">
                    {taskCountStatus.abort || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 6, sm: 4, md: 3, lg: 1.5 }}>
                <MaterialBox sx={{
                  p: 2,
                  backgroundColor: '#f5f5f5',
                  borderRadius: '12px',
                  textAlign: 'center',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.04)'
                }}>
                  <MaterialTypography variant="caption" color="textSecondary" fontWeight="medium" sx={{ mb: 0.5 }}>
                    Not Started
                  </MaterialTypography>
                  <MaterialTypography variant="h5" color="textSecondary" fontWeight="bold">
                    {taskCountStatus.notstarted || 0}
                  </MaterialTypography>
                </MaterialBox>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Search tasks by ID..."
                  value={filters.search}
                  onChange={(e) => handleFilterChange('search', e.target.value)}
                  size="small"
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    '& fieldset': { borderRadius: '8px' }
                  }}
                />
              </Grid>
            </Grid>
          </MaterialBox>
        )}

        <MaterialBox>
          <CollapsibleTable
            columns={columns}
            data={taskList}
            project_id={project_id}
            onEdit={handleEdit}
            onDelete={handleDelete}
            serverSide={true}
            totalCount={totalCount}
            page={currentPage}
            pageSize={pageSize}
            onPageChange={setCurrentPage}
            onPageSizeChange={(newPageSize) => {
              setPageSize(newPageSize);
              setCurrentPage(1);
            }}
            sortConfig={sortConfig}
            onSort={(key) => {
              setSortConfig(prev => ({
                key,
                direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
              }));
              setCurrentPage(1);
            }}
          />
        </MaterialBox>
      </MaterialBox>

      <Dialog open={openUploadDialog} onClose={handleCloseUploadDialog} fullWidth maxWidth="sm">
        <DialogTitle>Upload Task File</DialogTitle>
        <DialogContent>
          <MaterialBox sx={{ mt: 2 }}>
            <TextField
              size='medium'
              type="file"
              fullWidth
              variant="outlined"
              onChange={handleFileUpload}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                accept: ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
              }}
            />
          </MaterialBox>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleCloseUploadDialog} color="secondary" size="medium">
            Cancel
          </MaterialButton>
          <MaterialButton onClick={handleSubmitDocument} color="dark" variant="contained" size="medium">
            Upload
          </MaterialButton>
        </DialogActions>
      </Dialog>

      <Dialog open={rejectDialogOpen} onClose={handleRejectDialogClose} fullWidth maxWidth="sm">
        <DialogTitle>Reject Baseline</DialogTitle>
        <DialogContent>
          <MaterialBox sx={{ mt: 2 }}>
            <TextField
              size='medium'
              multiline
              rows={4}
              type="text"
              fullWidth
              variant="outlined"
              onChange={(e) => setRejectComment(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </MaterialBox>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={() => setRejectDialogOpen(false)} color="secondary" size="medium">
            Cancel
          </MaterialButton>
          <MaterialButton onClick={handleRejectBaseline} color="dark" variant="contained" size="medium">
            Submit
          </MaterialButton>
        </DialogActions>
      </Dialog>

      <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="xl" fullWidth>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
            fontSize: "16px",
            fontWeight: 600,
            py: 1
          }}
        >
          {selectedTask ? "Edit Task" : (baseline === -1 ? "Add Task" : "Request to Add Task")}
          <IconButton
            onClick={handleCloseDialog}
            size="small"
            sx={{
              width: 32,
              height: 32,
              borderRadius: 1,
              backgroundColor: "#fdecea",
              color: "#d32f2f",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                backgroundColor: "#f9d6d5"
              }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

        </DialogTitle>

        <DialogContent sx={{ py: 2, overflow: 'hidden' }}>
          <Grid container direction="row" spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 9 }}>
              <MaterialBox sx={{
                overflowX: 'auto',
                overflowY: 'auto',
                height: '75vh',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                p: 1
              }}>
                <div
                  style={{
                    width: "100%",
                    overflowX: "auto",
                  }}
                  className="custom-x-scroll"
                >
                  <table
                    style={{
                      width: "100%",
                      minWidth: "900px",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#f5f5f5",
                          textAlign: "left",
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                        }}
                      >
                        <th style={{ padding: "8px", borderBottom: "1px solid #ddd", color: "#ffffff", backgroundColor: '#5f6ec2' }}>Task ID</th>
                        <th style={{ padding: "8px", borderBottom: "1px solid #ddd", color: "#ffffff", backgroundColor: '#5f6ec2' }}>Milestone</th>
                        <th style={{ padding: "8px", borderBottom: "1px solid #ddd", color: "#ffffff", backgroundColor: '#5f6ec2' }}>Module</th>
                        <th style={{ padding: "8px", borderBottom: "1px solid #ddd", color: "#ffffff", backgroundColor: '#5f6ec2' }}>Task</th>
                        <th style={{ padding: "8px", borderBottom: "1px solid #ddd", color: "#ffffff", backgroundColor: '#5f6ec2' }}>Date</th>
                        <th style={{ padding: "8px", borderBottom: "1px solid #ddd", color: "#ffffff", backgroundColor: '#5f6ec2' }}>Employee</th>
                        <th style={{ padding: "8px", borderBottom: "1px solid #ddd", color: "#ffffff", backgroundColor: '#5f6ec2' }}>Hours</th>
                      </tr>
                    </thead>

                    <tbody>
                      {(selectedTask ? [selectedTask] : dialogTaskList).map((task, index) => (
                        <tr key={index}>
                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                            {renderCellWithTooltip(task.task_code)}
                          </td>

                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                            {renderCellWithTooltip(task.milestone_name)}
                          </td>

                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                            {renderCellWithTooltip(task.module_name)}
                          </td>

                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                            {renderCellWithTooltip(task.task_title)}
                          </td>

                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                            {renderCellWithTooltip(task.start_date)}
                          </td>

                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                            {renderCellWithTooltip(task.assignee_name)}
                          </td>

                          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
                            {renderCellWithTooltip(String(task.assigned_hours))}
                          </td>
                        </tr>
                      ))}

                      {(selectedTask ? [selectedTask] : dialogTaskList).length === 0 && (
                        <tr>
                          <td colSpan="7" style={{ padding: "20px", textAlign: "center" }}>
                            No tasks found
                          </td>
                        </tr>
                      )}
                    </tbody>

                  </table>
                </div>

              </MaterialBox>
            </Grid>


            <Grid size={{ xs: 12, sm: 12, md: 3 }}>
              <MaterialBox sx={{
                overflowY: 'auto',
                height: '75vh',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                p: 1
              }}>
                <TaskCreationForm
                  isDialog={true}
                  project_id={project_id}
                  fetchTaskList={fetchTaskList}
                  onClose={handleCloseDialog}
                  type={selectedTask ? "edit" : "add"}
                  data={selectedTask}
                />
              </MaterialBox>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #e0e0e0',
          pb: 2
        }}>
          <MaterialTypography variant="h6" fontWeight="bold">
            Approval History
          </MaterialTypography>
          <IconButton
            onClick={handleClose}
            size="small"
            sx={{
              width: 32,
              height: 32,
              borderRadius: 1,
              backgroundColor: "#fdecea",
              color: "#d32f2f",
              "&:hover": {
                backgroundColor: "#f9d6d5"
              }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{
          minHeight: '400px',
          maxHeight: '70vh',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none'
          },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none'
        }}>
          <ApprovalTimeline data={approvalHistoryData} />
        </DialogContent>
      </Dialog>

    </DashboardLayout>
  )
}

export default TaskCreationList